import React, { ReactElement } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import { ShareIconProps } from './Props'

const ShareIcon = (props: ShareIconProps): ReactElement => (
    <FontelloIcon name="share-android" paddingRight={1} {...props} />
)
export default ShareIcon
